/**
 * @fileoverview A foto do agente de IA ou, sem ela, as iniciais em cinza neutro
 * (sem cor por agente).
 */

import React from "react";

import { API_BASE_URL } from "../../../../services/api";
import { initialsOf } from "../../../../components/AiSetupAssistant/LearnedStep";
import useAgentStyles from "./styles";

const AgentAvatar = ({ name, profilePicUrl, size = "medium" }) => {
  const classes = useAgentStyles();
  const sizeClass = size === "small" ? classes.avatarSmall : size === "large" ? classes.avatarLarge : "";
  return (
    <span className={`${classes.avatar} ${sizeClass}`} aria-hidden="true">
      {profilePicUrl ? <img src={`${API_BASE_URL}/public/${profilePicUrl}`} alt="" /> : initialsOf(name)}
    </span>
  );
};

export default AgentAvatar;
